// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__Owhgm","list":"styles_list__xcZvw"};